export const ASC = 'ascending';
export const DESC = 'descending';



// WEBPACK FOOTER //
// ./src/config/constants.js